import actions from "./actions";

const initState = {
  blogInfo: {},
  blogs: {
    data: [],
  },
  loading: false,
  blogDeleted: false,
};

export default function fetchBlogsReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_BLOGS_REQUESTED:
      return {
        ...state,
        blogs: {
          data: [],
        },
        loading: true,
      };
    case actions.FETCH_BLOGS_SUCCEEDED:
      return {
        ...state,
        blogs: action.blogs,
        loading: false,
      };
    case actions.FETCH_BLOGS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.FETCH_BLOG_REQUESTED:
      return {
        ...state,
        blogInfo: {},
        loading: true,
      };
    case actions.FETCH_BLOG_SUCCEEDED:
      return {
        ...state,
        blogInfo: action.blog,
        loading: false,
      };
    case actions.FETCH_BLOG_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.DELETE_BLOG_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.DELETE_BLOG_SUCCEEDED:
      return {
        ...state,
        blogDeleted: true,
        loading: false,
      };
    case actions.DELETE_BLOG_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.CLEAR_BLOG:
      return initState;
    default:
      return state;
  }
}
